/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const KillswitchHistoryAction = {
  Created: "created",
  Edited: "edited",
  Lifted: "lifted",
  Expired: "expired",
  Restored: "restored",
} as const;
export type KillswitchHistoryAction = ClosedEnum<
  typeof KillswitchHistoryAction
>;

/** @internal */
export const KillswitchHistoryAction$inboundSchema: z.ZodMiniEnum<
  typeof KillswitchHistoryAction
> = z.enum(KillswitchHistoryAction);
